module.exports = __webpack_public_path__ + "static/media/product_video_placeholder.b20f8a72.png";